(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-blog-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll('.blog-feature-slider').forEach(section => {

    const swiperEl = section.querySelector('.blog-swiper');

    if (swiperEl) {
      const swiper = new Swiper(swiperEl, {
        slidesPerView: 1.7,
        spaceBetween: 16,
        loop: false,
        breakpoints: {
          552: { slidesPerView: 2.4 },
          768: { slidesPerView: 3.4 },
          991: { slidesPerView: 4 }
        },
        on: {
          init: () => safeBalance(section),
          slideChange: () => safeBalance(section),
          resize: () => safeBalance(section)
        }
      });
    }

    equalizeBlogTitles(section);

    window.addEventListener('load', () => {
      equalizeBlogTitles(section);
      safeBalance(section);
    });

  });

});


/* ===========================
   DESKTOP GRID TITLE HEIGHTS
=========================== */
function equalizeBlogTitles(section) {
  const rows = section.querySelectorAll('.article-grid');

  rows.forEach(row => {
    let maxHeight = 0;
    const titles = row.querySelectorAll('.bolg-title');

    titles.forEach(title => {
      title.style.height = 'auto';
      maxHeight = Math.max(maxHeight, title.offsetHeight);
    });

    titles.forEach(title => {
      title.style.height = maxHeight + 'px';
    });
  });
}


/* ===========================
   SAFELY BALANCE ONE SECTION
=========================== */
function safeBalance(section){

  // wait for layout to settle (prevents cross-section bleed)
  requestAnimationFrame(() => {

    const cards = section.querySelectorAll('.swiper-slide .article-card');
    if (!cards.length) return;

    const titles = section.querySelectorAll('.swiper-slide .bolg-title');
    const descriptions = section.querySelectorAll('.swiper-slide .article-description');

    /* ---- reset ---- */
    titles.forEach(t => t.style.height = 'auto');
    descriptions.forEach(d => d.style.webkitLineClamp = 2);

    /* ---- find tallest title ONLY IN THIS SECTION ---- */
    let maxTitleHeight = 0;
    titles.forEach(t => {
      maxTitleHeight = Math.max(maxTitleHeight, t.offsetHeight);
    });

    /* ---- lock titles to section max ---- */
    titles.forEach(title => {
      title.style.height = maxTitleHeight + 'px';
    });

    /* ---- expand description based on diff ---- */
    titles.forEach(title => {

      const desc = title.closest('.article-card')
                        .querySelector('.article-description');
      if (!desc) return;

      const diff = maxTitleHeight - title.offsetHeight;
      if (diff <= 0) return;

      const lineHeight = parseFloat(getComputedStyle(desc).lineHeight);
      if (!lineHeight) return;

      const extraLines = Math.round(diff / lineHeight);

      desc.style.webkitLineClamp = 2 + extraLines;

    });

  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-faq-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    new Swiper(".blog-slide", {
      slidesPerView: 1.7,
      spaceBetween: 32,
           loop: true,                 
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        552: {
          slidesPerView: 2.4,
        },
        768: {
          slidesPerView: 3.4,
        },
        991: {
          slidesPerView: 4.5,
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-pages-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    new Swiper(".blog-swiper", {
      slidesPerView: 1.7,
      spaceBetween: 16,
      loop: false,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        552: {
          slidesPerView: 2.4,
        },
        768: {
          slidesPerView: 3.4,
        },
      991: {
          slidesPerView: 4,
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
